export default __webpack_public_path__ + "static/media/Gotham-Book.c6d701d8.otf";